module.exports = __webpack_public_path__ + "static/media/p2.4dc93348.jpeg";